import { render } from "./LayoutDispatcher.vue?vue&type=template&id=7707de00&scoped=true"
import script from "./LayoutDispatcher.vue?vue&type=script&lang=js"
export * from "./LayoutDispatcher.vue?vue&type=script&lang=js"

import "./LayoutDispatcher.vue?vue&type=style&index=0&id=7707de00&lang=less&scoped=true"

import exportComponent from "/Users/kacper/IdeaProjects/e.on-portal-awarie/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7707de00"]])

export default __exports__